import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateUserLocaleParams {
  userId: string; // server user id
  locale: string;
}

export class UpdateUserLocaleRequest extends Request<IUpdateUserLocaleParams, IResult> {
  constructor(params: IUpdateUserLocaleParams) {
    super('updateUserLocale', params);
  }
}
